<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="true"
             color="green"
             loader="dots"
    ></loading>
    <div class="row">
      <div class="col-md-8 col-8">
        <h3 class="title m-t-10 m-l-15" v-if="library">{{ library.title }}</h3>
        <ol class="breadcrumb" style="margin-top: -20px">
          <li class="breadcrumb-item"><a href="/"><i class="mdi mdi-home"></i> На головну</a></li>
          <li class="breadcrumb-item active">Книги звітів</li>
        </ol>
      </div>
      <div class="col-4">
        <div class="p-t-10 position-fixed" style="right: 40px;">
          <button @click="storeReport"
                  class="btn btn-success" style="font-size: 15px;letter-spacing: -0.3px;">
            <img src="/theme/icons/add-book.svg" alt="" class="m-r-10">
            Створити звіт
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body" style="overflow-x: auto">
        <div class="container-fluid">
          <div class="row">
            <table class="table reader table-books">
              <thead>
              <tr>
                <th>
                  Дата
                </th>
                <th>
                  Період
                </th>
                <th>

                </th>
                <th>

                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="report in reports">
                <td>
                  <b>{{ moment(report.created_at).format("YYYY-MM-DD hh:mm:ss") }}</b>
                </td>
                <td>
                  <b>{{ report.period }}</b>
                </td>
                <td v-if="report.url == 'none'">
                  Нажаль не має актів для створення звіту
                </td>
                <td v-else-if="report.url">
                  <a :href="'/'+report.url" target="_blank" class="btn btn-success" style="color:white;width: unset;height: unset" ><b>Завантажити</b></a>
                </td>
                <td v-else>
                  <button @click="getReports" class="btn btn-success" style="width: unset;height: unset"><b>Виконується</b></button>
                </td>
                <td>
                  <button class="btn btn-danger" @click="deleteReport(report.id)">Видалити</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="mr-auto">
<!--              <div class="m-t-10 p-t-30 m-l-30 footer-card">{{ reports.length }} із {{ rows }}-->
<!--                записів-->
<!--              </div>-->
            </div>
            <div class="ml-auto">
              <div class="m-t-10 p-t-30">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="getReports()"
                ></b-pagination>
<!--                <b-form-input type="number" @change="currentPage = $event"></b-form-input>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "BookReports",
  components:{
    Loading
  },
  mounted() {
    axios.get('/library').then(res =>{
      this.library = res.data;
    });
    this.getReports();
  },
  data(){
    return {
      isLoading:false,
      library:null,
      reports:[],
      rows:0,
      perPage:0,
      currentPage:1
    }
  },
  methods:{
    getReports(){
      this.isLoading = true;
      axios.get('/library/book-reports',{params:{page:this.currentPage}}).then(response => {
        this.reports = response.data.data;
        this.rows = response.data.total;
        this.perPage = response.data.per_page;
        this.isLoading = false;
      });
    },
    storeReport(){
      axios({
        url:'/library/book-reports',
        method:"post"
      }).then(response => {
        this.getReports();
      });
    },
    deleteReport(id){
      Swal.fire({
        title: 'Видалити звіт?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Так, видалити',
        cancelButtonText: 'Ні'
      }).then((result) => {
        if (result.value) {
          axios({
            url:'/library/book-reports/'+id,
            method:"delete"
          }).then(response => {
            if(response.data.status === 'success'){
              this.getReports();

              Swal.fire(
                  'Видалено!',
                  '',
                  'success'
              )
            }else{
              Swal.fire(
                  'Не видалено!',
                  response.data.message,
                  'warning'
              )
            }
          });

        }
      })
    },
    moment: function (date) {
      return moment(date);
    },
  }
}
</script>

<style scoped>

</style>